<script lang="ts" setup>
withDefaults(
  defineProps<{
    withBorder?: boolean
  }>(),
  { withBorder: true }
)
</script>

<template>
  <div class="rounded-xl p-3 md:p-6" :class="{ 'border border-solid border-main-gray': withBorder }">
    <slot />
  </div>
</template>
